import 'controllers'

require('javascripts/cookie-policy-onscroll')
require('javascripts/honeybadger')
require('javascripts/navigation')

import 'stylesheets/app_store_next.scss'

document.addEventListener('DOMContentLoaded', function () {
  const utmArray = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
  ]

  const handleUTMParameters = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const signupLinks = document.querySelectorAll('[href^="/signup"]')

    const queryParams = utmArray
      .map((key) => {
        const UTMParam = urlParams.get(key)
        if (UTMParam) {
          return `${key}=${urlParams.get(key)}`
        }
      })
      .filter((param) => param)
      .join('&')

    if (queryParams) {
      signupLinks.forEach((el) => {
        const href = el.getAttribute('href')
        if (href.includes('?')) {
          el.setAttribute('href', `${href}${queryParams}`)
        } else {
          el.setAttribute('href', `${href}?${queryParams}`)
        }
      })
    }
  }
  handleUTMParameters()
})
